import React, { useEffect } from "react"
import Timeline, { timelineClasses }  from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Card } from "../components/Card";
import { CarIcon } from "../components/Icons";
import { FormattedCurrency } from '@sb1finans/components/dist/FormattedCurrency';
import Typography from "@mui/material/Typography"
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from "@mui/material/Stack"
import { accountsApi } from "../api";
import { Transaction } from "@sb1finans/banking-api/dist/api";

interface AccountTransactionsProps {
    agreementId: string;
    accountId: string;
}

export const AccountTransactions: React.FC<AccountTransactionsProps> = ({agreementId, accountId}) => {

    
    const [transactions, setTransactions] = React.useState<Transaction[]>([])
    const [loading, setLoading] = React.useState(true)
    const [error, setError] = React.useState<Error | null>(null)

    const fetchTransactions = async () => {
        try {
            const transactionsResponse = await accountsApi.listAccountTransactions(agreementId, accountId, {timeout: 60000})
            setTransactions(transactionsResponse.data)
        } catch (error: any) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchTransactions()
    }, [])

    const transactionGroup = transactions.reduce((acc, transaction) => {
        const date = new Date(transaction.transactionDate)
        const key = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}`
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(transaction)
        return acc
    }, {} as {[key: string]: Transaction[]})

    const mapDescription = (description: string) => {
        switch (description) {
            case "INSTALLMENT":
                return "Avdrag"
            case "INCURRED_INTEREST":
                return "Renter"
            default:
                return ""
        }
    }

    return (
        <>
            { error && <Alert severity="error">En feil oppstod ved henting av kontobevegelser.</Alert> }
            { loading &&
                <Stack alignItems="center" sx={{padding: "24px 0px"}}>
                    { loading && <CircularProgress /> }
                </Stack>
            }
            <Timeline
                sx={{
                    "& .MuiTimelineItem-missingOppositeContent:before": { 
                        content: "none" 
                    },
                }}
            >
                {   
                    Object.entries(transactionGroup).map(([key, transactions]) => {

                        const date = new Date(transactions[0].transactionDate)
                        const month = date.toLocaleString('default', { month: 'long' })
                        const year = date.getFullYear()

                        return (
                            <TimelineItem key={key}>
                                <TimelineSeparator>
                                    <TimelineDot />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Typography variant="h6" component="h1" sx={{ mb: 1 }}>
                                        {date.getDate()} {month} {year}
                                    </Typography>
                                    {transactions.map((transaction) => {
                                        console.info(mapDescription(transaction.transactionType))
                                        console.info(transaction.transactionID)
                                        console.info(transaction.amount)
                                       return (
                                        <Card
                                            key={transaction.transactionID + Math.random()}
                                            title={mapDescription(transaction.transactionType)}
                                            subtitle={<FormattedCurrency round={true}>{transaction.amount}</FormattedCurrency>} />
                                        )})}
                                </TimelineContent>
                            </TimelineItem>
                        )
                    })
                }
            </Timeline>
        </>
    )
}